package com.arena_web.data.repository

import com.arena_web.data.api.PeopleApi
import com.arena_web.data.dto.PeopleFeedDto
import com.arena_web.data.dto.PeopleInteractionsCountDto
import com.arena_web.data.dto.PeopleInteractionsDto
import com.arena_web.data.dto.SwipeRequest
import com.arena_web.data.dto.SwipeResponse
import com.arena_web.domain.repositories.PeopleRepository

class PeopleRepositoryImpl(private val peopleApi: PeopleApi) : PeopleRepository {

    override suspend fun getFeed(size: Int, offset: Long): Result<PeopleFeedDto> =
        apiCall { peopleApi.getFeed(size, offset) }

    override suspend fun getPublicFeed(size: Int, offset: Long): Result<PeopleFeedDto> =
        apiCall { peopleApi.getPublicFeed(size, offset) }

    override suspend fun swipe(targetUserId: String, action: String): Result<SwipeResponse> =
        apiCall { peopleApi.swipe(targetUserId, SwipeRequest(action)) }

    override suspend fun getInteractions(): Result<PeopleInteractionsDto> =
        apiCall { peopleApi.getInteractions() }

    override suspend fun getInteractionsCount(): Result<PeopleInteractionsCountDto> =
        apiCall { peopleApi.getInteractionsCount() }
}
